// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.VIEW_REWARD.REWARD_FAQ

export const REWARD_FAQ = {
  TAB_VIEWED: 'faq-tab_viewed'
};
